import { render } from "./AddEmploiPage.vue?vue&type=template&id=1cba8cfa&ts=true"
import script from "./AddEmploiPage.vue?vue&type=script&lang=ts"
export * from "./AddEmploiPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__